(ns frontend.view.modals.nylas-connect.model)

(def root-path [::state])

(def keep-private?-key :keep-private?)
(def keep-private?-full-path (into root-path [keep-private?-key]))

(def sync-contacts?-key :sync-contacts?)
(def sync-contacts?-full-path (into root-path [sync-contacts?-key]))

(def email-hint-path :email-hint)
(def email-hint-full-path (into root-path [email-hint-path]))
